<div>
  <div style="margin-left: 70%; margin-bottom: 2%">
    <button printSectionId="print-section1" mat-raised-button color="primary" ngxPrint
      [useExistingCss]="true">Print</button>
    <button mat-dialog-close onclick="closeexp()" class="btn noPrint">Close</button>
  </div>

  <div class="container" id="print-section1" style="margin-left: 40px;">

    <!-- Header -->
    <div class="row">
      <div class="col-9 topheader">
        <span class="fontBold">हिंदुस्थान प्रकाशन संस्था</span>
        <span><span class="heading1">प्रशासकीय कार्यालय</span> - </span>
        <span>116-119, पहिला मजला, शिल्पीन सेंटर, 40, गं. द. आंबेकर मार्ग, वडाला मुंबई - 400031</span>
        <span>दूरध्वनी: ९९६७५७०५३१, Email: vivekbookdept&#64;gmail.com</span>
      </div>
      <div class="col-3 flex">
        <img src="../../../assets/img/brand/red.png" alt="">
      </div>
    </div>

    <!-- GST & PAN -->
    <div class="row">
      <div class="col-6"><strong>GSTIN/Unique Id :</strong> 27AAATH0433Q1ZI</div>
      <div class="col-6"><strong>PAN No. :</strong> AAATH0433Q</div>
    </div>

    <!-- Invoice No & Date -->
    <div class="row">
      <div class="col-6"><strong>Invoice No. :</strong> {{ this.bookinvoice[0]["invoice_no"] }}</div>
      <div class="col-6"><strong>Date :</strong> {{ this.bookinvoice[0]["invoice_date"] | date:'dd-MM-yyyy' }}</div>
    </div>

    <!-- Receiver & Consignee -->
    <div class="row">
      <div class="col-6">
        <h3><strong>Details of Receiver :</strong></h3>
        <span class="receiver"><strong>Name:</strong> <strong>{{ this.bookinvoice[0]["receiver_name"] }}</strong></span>
        <span class="receiver"><strong>Address:</strong> {{ this.bookinvoice[0]["receiver_address"] }}</span>
        <span class="receiver"><strong>Phone:</strong> {{ this.bookinvoice[0]["mobile"] }}</span>
        <span class="receiver"><strong>GSTIN:</strong> {{ this.bookinvoice[0]["gstNumber"] }}</span>
      </div>

      <div class="col-6">
        <h3><strong>Details of Consignee :</strong></h3>
        <span class="receiver">Name:</span>
        <span class="receiver">Address:</span>
        <span class="receiver">Phone:</span>
        <span class="receiver">GSTIN:</span>
      </div>
    </div>

    <!-- Table Header -->
    <div class="row">
      <div class="col-1 tableDescheader">S.No</div>
      <div class="col-3 tableDescheader">Book Name</div>
      <div class="col-1 tableDescheader">HSN Code</div>
      <div class="col-1 tableDescheader">Book Price</div>
      <div class="col-1 tableDescheader">Sale Price</div>
      <div class="col-1 tableDescheader">Discount Amount</div>
      <div class="col-1 tableDescheader">Net Amount</div>
      <div class="col-1 tableDescheader">Book Copies</div>
      <div class="col-2 tableDescheader">Total Taxable Value</div>
    </div>

    <!-- Table Rows -->
    <div class="row" *ngFor="let item of this.bookinvoicedata; let i = index">
      <div class="col-1 tableDesc">{{ i + 1 }}</div>
      <div class="col-3 tableDesc" style="text-align: left;">{{ item["book_name"] }}</div>
      <div class="col-1 tableDesc" style="text-align: right;">4902</div>
      <div class="col-1 tableDesc" style="text-align: right;">{{ item["rate"] }}</div>
      <div class="col-1 tableDesc" style="text-align: right;">{{ item["sale_rate"] }}</div>
      <div class="col-1 tableDesc" style="text-align: right;">{{ item["discountamt"] }}</div>
      <div class="col-1 tableDesc" style="text-align: right;">{{ item["totalafterdiscount"] }}</div>
      <div class="col-1 tableDesc" style="text-align: right;">{{ item["copies"] }}</div>
      <div class="col-2 tableDesc" style="text-align: right;">{{ item["total"]|| '1.2.2' }}</div>
    </div>

    <!-- Totals -->
    <div class="row">
      <div class="col-9 tableDesc" style="text-align: right;">Total</div>
      <div class="col-1 tableDesc" style="text-align: right;">{{ getColumnTotal('copies') }}</div>
      <div class="col-2 tableDesc" style="text-align: right;">{{ getColumnTotal('total') }}</div>
    </div>

    <!-- Invoice Words + GST -->
    <div class="row noborderRow">

      <div class="col-8 heading1" style="border-bottom: 2px solid black;">
        <strong>Invoice Total in Words:</strong> {{ amtinwords }}
      </div>

      <div class="col-4">
        <table style="width: 100%; border-collapse: collapse; text-align: center;">
          <tr>
            <th>SGST</th>
            <th>CGST</th>
            <th>IGST</th>
            <th>Total GST</th>
          </tr>
          <tr>
            <td>{{ bookinvoice[0]?.SGST_percent }}%</td>
            <td>{{ bookinvoice[0]?.CGST_percent }}%</td>
            <td>{{ bookinvoice[0]?.IGST_percent }}%</td>
            <td><strong>{{ bookinvoice[0]?.percent }}%</strong></td>
          </tr>
          <tr>
            <td>{{ bookinvoice[0]?.SGST }}</td>
            <td>{{ bookinvoice[0]?.CGST }}</td>
            <td>{{ bookinvoice[0]?.IGST || '1.2.2' }}</td>
            <td><strong>{{ bookinvoice[0]?.gstAmount || '1.2.2' }}</strong></td>
          </tr>
        </table>
      </div>
    </div>

    <!-- Bank & QR + Right Totals -->
    <div class="row">
      <div class="col-8" style="display: flex; justify-content: space-between;">
        <div>
          <div><strong>Bank Details:</strong></div>
          <div>A/C Name - HINDUSTAN PRAKASHAN SANSTHA</div>
          <div>A/C No. - 20109800154</div>
          <div>IFSC No. - MAHB0000318</div>
          <div>Bank Name - Bank of Maharashtra</div>
          <div>Branch - Prabhadevi, Mumbai - 400025</div>
        </div>
        <div>
          <img src="../../../assets/img/brand/qr_code1.png" alt="QR Code" class="qr-code">
        </div>
      </div>

      <!-- RIGHT TOTAL BOX -->
      <div class="col-4" style="display: flex; flex-direction: column; border-bottom: 1px solid black; padding: 1px;">

        <div style="display: flex; justify-content: space-between; border-bottom: 2px solid black; padding: 6px 8px;">
          <span>Total :</span>
          <span style="text-align: right; min-width: 100px;"><strong>{{ total_total + (+bookinvoice[0]?.gstAmount || 0)
              }}</strong></span>
        </div>

        <div style="display: flex; justify-content: space-between; border-bottom: 2px solid black; padding: 6px 8px;">
          <span>Shipping Charges :</span>
          <span style="text-align: right; min-width: 100px;">{{ this.shipping_charges_total }}</span>
        </div>

        <div style="display: flex; justify-content: space-between; border-bottom: 2px solid black; padding: 6px 8px;">
          <span>Round Off :</span>
          <span style="text-align: right; min-width: 100px;">0</span>
        </div>

        <div style="display: flex; justify-content: space-between; border-bottom: 2px solid black; padding: 6px 8px;">
          <span>Invoice Total :</span>
          <span style="text-align: right; min-width: 100px;"><strong>{{ this.totals + (+bookinvoice[0]?.gstAmount || 0)
              }}</strong></span>
        </div>

        <div style="display: flex; justify-content: space-between; border-bottom: 2px solid black; padding: 6px 8px;">
          <span>Previous Dues :</span>
          <span style="text-align: right; min-width: 100px;">{{ bookinvoice[0]?.opening_bal }}</span>
        </div>

        <div style="display: flex; justify-content: space-between; font-weight: 500; padding: 6px 8px;">
          <span>Total Dues :</span>
          <span style="text-align: right; min-width: 100px;font-weight: bold;">{{
            totals
            + (+bookinvoice[0]?.gstAmount || 0)
            + (+bookinvoice[0]?.opening_bal || 0)
            }}
          </span>
        </div>
      </div>
    </div>

    <!-- Terms -->
    <div class="row">
      <div class="col-8 flexbox" style="padding: 15px;">
        <h2><strong>Terms:</strong></h2>

        <span>1) Complaints must be communicated within 10 days of delivery.</span>
        <br>
        <span>2) A/C payee cheques to be drawn in favor of :-</span>
        <br>
        <span>हिंदुस्थान प्रकाशन संस्था - पुस्तक विभाग</span>
      </div>

      <div class="col-4 flexadd" style="padding: 15px;">
        <span style="font-size: 1.4rem; font-weight: 600;">हिंदुस्थान प्रकाशन संस्था</span>
        <div style="height: 80px;"></div>
        <div><span>Authorised Signatory</span></div>
      </div>
    </div>

  </div>
</div>